/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { memo, useCallback, useState } from 'react';
import { connect, ConnectedProps, useDispatch } from 'react-redux';

import { PageOverlay } from '../../components/PageOverlay/PageOverlay';
import { CREATE_CLUSTER_OVERLAY_CSS_ANCHOR } from '../../constants/settings';
import { RootState } from '../../store';
import { closeCreateClusterOverlay } from '../../store/createCluster/actions';
import { CreateClusterOverlayForm } from './CreateClusterOverlay.Form';
import { CreateClusterOverlayFormBackup } from './CreateClusterOverlay.FormBackup';

const mapState = (state: RootState) => ({
  createCluster: state.createCluster,
});

const connector = connect(mapState);
type PropsFromRedux = ConnectedProps<typeof connector>;

type CreateClusterOverlayProps = PropsFromRedux;

const CreateClusterOverlayComponent = memo<CreateClusterOverlayProps>(props => {
  const { createCluster } = props;
  const { isOpen, fromBackup } = createCluster;
  const dispatch = useDispatch();
  const [stickyButtons, setStickyButtons] = useState<boolean>(false);

  const close = useCallback(() => {
    dispatch(closeCreateClusterOverlay());
  }, [dispatch]);

  const onClusterCreate = useCallback(() => {
    close();
  }, [close]);

  return (
    <PageOverlay
      open={isOpen}
      classes={{ childrenBlock: 'd-flex' }}
      showCloseBtn
      onCloseBtnClick={close}
      disableRestoreFocus
      className={CREATE_CLUSTER_OVERLAY_CSS_ANCHOR}
      stickyButtons={stickyButtons}
      name="create-cluster"
    >
      {isOpen ? (
        fromBackup ? (
          <CreateClusterOverlayFormBackup
            onClusterCreate={onClusterCreate}
            skipDatasetStep={true}
            setStickyButtons={setStickyButtons}
          />
        ) : (
          <CreateClusterOverlayForm onClusterCreate={onClusterCreate} setStickyButtons={setStickyButtons} />
        )
      ) : null}
    </PageOverlay>
  );
});

export const CreateClusterOverlay = connector(CreateClusterOverlayComponent);
